export const PRODUCT_BRAND = Object.freeze({
  name: "Wavelines ERP",
  tagline: "Run your whole business.",
  symbol: "/brand/product-symbol.svg",
  favicon: "/brand/favicon.svg",
  appIcon: "/brand/app-icon.svg",
  logoLight: "/brand/logo-light.svg",
  logoDark: "/brand/logo-dark.svg",
  splash: "/brand/splash.svg",
});

export function applyAppBranding() {
  // Wavelines owns product identity. Tenant/admin uploads may brand the tenant's
  // business-facing surfaces, but never the browser, launcher, PWA or product shell.
  const name = PRODUCT_BRAND.name;
  document.title = name;

  let favicon = document.querySelector("link[rel~='icon']");
  if (!favicon) {
    favicon = document.createElement("link");
    favicon.rel = "icon";
    document.head.appendChild(favicon);
  }
  favicon.type = "image/svg+xml";
  favicon.href = PRODUCT_BRAND.favicon;

  let apple = document.querySelector("link[rel='apple-touch-icon']");
  if (!apple) {
    apple = document.createElement("link");
    apple.rel = "apple-touch-icon";
    document.head.appendChild(apple);
  }
  apple.href = PRODUCT_BRAND.appIcon;

  document.querySelector("meta[name='application-name']")?.setAttribute("content", name);
  document.querySelector("meta[name='apple-mobile-web-app-title']")?.setAttribute("content", name);

  // Keep the real, same-origin /manifest.json declared by index.html. A data: manifest
  // created at runtime can race browser installability checks and hide the static PWA
  // metadata. The checked-in manifest is the single source of truth for installation.
  let manifestLink = document.querySelector("link[rel='manifest']");
  if (!manifestLink) {
    manifestLink = document.createElement("link");
    manifestLink.rel = "manifest";
    manifestLink.href = "/manifest.json";
    document.head.appendChild(manifestLink);
  }

  try {
    localStorage.removeItem("wavelines_app_settings");
    localStorage.removeItem("platform_app_settings");
  } catch {}
}
